"use strict";
/*jshint esversion: 11 */

import React, {Fragment} from "react";
import PropTypes from "prop-types";
import { getTodayLongDate } from "../utils/utils";

export default function CsfMembreDossierUfcPrint({
  ufcList,
  periodTitle,
  periodSubTitle,
  memberName,
  certificatNumber,
  tableId,
  conformityEndDate
}) {
  const langcode = document.documentElement.lang;
  return (
    <div className="print-wrapper">
      <div className="print-page">
        <div className="print-header">
          <img src="/themes/custom/tink/dist/assets/print-black-logo.png"
            alt="Chambre de la sécurité financière" />
          <h1>
            {window.Drupal.t('membre.print.summary.headline1')} {window.Drupal.t('membre.heading.cert')} {certificatNumber}
          </h1>
          <p>
            {window.Drupal.t('fournisseur.print.p1.section1.header.submitted')} {getTodayLongDate(document.documentElement.lang)}
            {' ' + window.Drupal.t('fournisseur.print.p1.section1.header.by')} {memberName}
          </p>
        </div>

        <div className="print-section">
          <h2>{window.Drupal.t('membre.dossierUFC.title')}</h2>
          <p>{periodTitle} ({periodSubTitle})</p>
          <div className="inner-wrapper">
            <div className="table-wrapper-ufc">
              <table className="summary__table">
                <thead>
                <tr>
                  <th>
                    {window.Drupal.t('membre.summary.category')}
                  </th>
                  <th>
                    {window.Drupal.t('membre.summary.asked-ufc')}
                  </th>
                  <th>
                    {window.Drupal.t('membre.summary.completed-ufc')}
                  </th>
                  <th>
                    {window.Drupal.t('membre.summary.missing-ufc')}
                  </th>
                  <th width="160">
                    {window.Drupal.t('membre.summary.completed')}
                  </th>
                </tr>
                </thead>
                <tbody>
                  {ufcList?.length === 0 ? (
                    <tr>
                      <td colSpan="6">
                        <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
                      </td>
                    </tr>
                  ) : (<></>)}
                  {ufcList.map((item, index) => (
                    <Fragment key={`${item.REDU_Edu_File__Subject_Id}-print-${index}-${tableId}`}>
                      <tr className={index % 2 === 0 ? 'even' : 'odd'}>
                        <td>
                          {langcode === 'fr' ?  item.Subject_Name_French : item.Subject_Name_English}
                        </td>
                        <td>
                          {item.UFC_Required}
                        </td>
                        <td>
                          {item.UFC_Aquired_Total}
                        </td>
                        <td>
                          {item.UFC_Missing_Total}
                        </td>
                        <td>
                          {item.In_Order === 'Oui' || item.In_Order === 'Yes' ? (
                            <span
                              className="espaces__tag ">{window.Drupal.t('Yes')}</span>
                          ) : item.In_Order === 'Non' || item.In_Order === 'No' ? (
                            <span
                              className="espaces__tag espaces__tag--error ">{window.Drupal.t('No')}</span>
                          ) : (
                            <span title={window.Drupal.t('membre.tag.na.tooltip')}
                              className="espaces__tag espaces__tag--gray ">{window.Drupal.t('membre.tag.na')}</span>
                          )}
                        </td>
                      </tr>
                      {/* Row "conformité" */}
                      {
                        item.REDU_Subject_Id === 'AAAAAAAAACI=' && (
                          <tr key={`${item.REDU_Edu_File__Subject_Id}-extra-${tableId}`} className="odd extra-row">
                            <td colSpan="5" className="pt-0">
                              <div className="d-flex justify-content-between flex-wrap align-items-center">
                                <p className="text-left mt-0">
                                  {window.Drupal.t('membre.course.to.complete')}<br />
                                  {conformityEndDate && (
                                    <span className="espaces__extra-details">{window.Drupal.t('membre.course.to.complete.desc')} {conformityEndDate}</span>
                                  )}
                                </p>
                                <div>
                                  {item.UFC_Acquired_Mandatory === 1 ? (
                                    <img src="/themes/custom/tink/dist/assets/icon-member-check.svg" alt="" aria-label={window.Drupal.t('broker.compliance.ufcAcquiredMandatory.fromapi')} />
                                  ) : (
                                    <img src="/themes/custom/tink/dist/assets/icon-member-clock.svg" alt="" />
                                  )}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )
                      }
                    </Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CsfMembreDossierUfcPrint.propTypes = {
  ufcList: PropTypes.array.isRequired,
  periodTitle: PropTypes.string,
  periodSubTitle: PropTypes.string,
  memberName: PropTypes.string,
  certificatNumber: PropTypes.string,
  tableId: PropTypes.string,
  conformityEndDate: PropTypes.string
};

